import React, { useState } from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { CALENDLY_URL } from "../../i18n";
import { leadsApi } from "../../api";
import { useLang } from "../../context/LangContext";
import { toast } from "sonner";

export default function StrategySession() {
  const { c } = useLang();
  const s = c.contact;
  const [form, setForm] = useState({ first: "", last: "", phone: "", email: "", role: "", goal: "", consent: false });

  const submit = async () => {
    if (!form.email || !form.phone) { toast.error(c.toast.leadReq); return; }
    try {
      await leadsApi.createLead({ firstName: form.first, lastName: form.last, phone: form.phone, email: form.email, role: form.role, goal: form.goal, consent: form.consent });
      toast.success(c.toast.leadOk);
      setForm({ first: "", last: "", phone: "", email: "", role: "", goal: "", consent: false });
    } catch (e) { toast.error(c.toast.leadErr); }
  };

  return (
    <section id="contact" className="section">
      <div className="container-x" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4rem", alignItems: "start" }}>
        <div className="reveal">
          <span className="eyebrow">{s.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2rem,4.5vw,3.6rem)", margin: "1.2rem 0 1.6rem" }}>
            {s.title.pre}<span className="italic-gold">{s.title.em}</span>{s.title.post}
          </h2>
          <p className="body-text" style={{ marginBottom: "2.4rem" }}>{s.para}</p>
          <div style={{ display: "grid", gap: "1.4rem", marginBottom: "2.4rem" }}>
            {s.steps.map((st, i) => (
              <div key={i} style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
                <span className="font-serif" style={{ fontSize: "1.4rem", color: "var(--gold)", minWidth: 28 }}>{i + 1}.</span>
                <span style={{ color: "var(--text)", fontSize: "0.95rem", lineHeight: 1.6 }}>{st}</span>
              </div>
            ))}
          </div>
          <div className="card" style={{ padding: "2rem", background: "linear-gradient(180deg, rgba(201,162,75,0.05), transparent)" }}>
            <h3 className="font-serif" style={{ fontSize: "1.4rem", marginBottom: "0.4rem" }}>{s.scheduleTitle}</h3>
            <p className="body-text" style={{ fontSize: "0.85rem", marginBottom: "1.4rem" }}>{s.schedulePara}</p>
            <a href={CALENDLY_URL} target="_blank" rel="noreferrer" className="btn-gold"><Calendar size={15} /> {s.scheduleBtn}</a>
          </div>
        </div>

        <div className="card" style={{ padding: "2.6rem" }}>
          <h3 className="font-serif" style={{ fontSize: "1.7rem", marginBottom: "1.6rem" }}>{s.formTitle}</h3>
          <div style={{ display: "grid", gap: "0.9rem" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.7rem" }}>
              <input className="field" placeholder={s.first} value={form.first} onChange={(e) => setForm({ ...form, first: e.target.value })} />
              <input className="field" placeholder={s.last} value={form.last} onChange={(e) => setForm({ ...form, last: e.target.value })} />
            </div>
            <input className="field" placeholder={s.phone} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <input className="field" placeholder={s.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <select className="field" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
              <option value="">{s.roleLabel}</option>
              {s.roles.map((r) => <option key={r}>{r}</option>)}
            </select>
            <select className="field" value={form.goal} onChange={(e) => setForm({ ...form, goal: e.target.value })}>
              <option value="">{s.goalLabel}</option>
              {s.goals.map((g) => <option key={g}>{g}</option>)}
            </select>
            <label style={{ display: "flex", gap: "0.7rem", alignItems: "flex-start", fontSize: "0.75rem", color: "var(--muted-2)", lineHeight: 1.5, cursor: "pointer" }}>
              <input type="checkbox" checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} style={{ marginTop: 3, accentColor: "var(--gold)" }} />
              <span>{s.consent}</span>
            </label>
            <button className="btn-gold" style={{ width: "100%" }} onClick={submit}>{s.submit} <ArrowRight size={14} /></button>
          </div>
        </div>
      </div>
    </section>
  );
}
